import "./Course.css";
import { Component } from "react";
import PropTypes from "prop-types";

class Course extends Component {
  state = {
    status: this.props.course.status, // status of course
  };

  // Update course status if user selects different status; remove course if user selects "none"
  handleChange = (event) => {
    event.preventDefault();
    if (event.target.value !== "none") {
      this.setState({ status: event.target.value }, () => {
        this.props.updateCourse(this.props.course._id, event.target.value);
      });
    } else {
      this.setState({ status: event.target.value }, () => {
        this.props.removeCourse(this.props.course._id);
      });
    }
  }

  render() {
    return (
      <li>
        <div className="course">
          <div className="course-top">
            <svg className="course-logo">
              <rect
                x={0}
                y={0}
                width={128}
                height={128}
                fill={this.props.course.color}
              />
              <text
                x="50%"
                y="35%"
                textAnchor="middle"
                dominantBaseline="middle"
                fill="white"
                fontFamily="monospace"
                fontSize="2.2em"
              >
                <tspan x="50%" dy="0">
                  {this.props.course.number.substring(0, 3)}
                  </tspan>
                <tspan x="50%" dy="1.2em">
                  {this.props.course.number.substring(4, 7)}
                  </tspan>
              </text>
            </svg>
            <div className="course-status-changer">
              <select value={this.state.status} onChange={this.handleChange}>
                <option value="move" disabled>Move to...</option>
                <option value="enrolled">Currently Enrolled</option>
                <option value="interested">Want to Take</option>
                <option value="taken">Already Took</option>
                <option value="none">None</option>
              </select>
            </div>
          </div>
          <div className="course-title">
            {this.props.course.title}
          </div>
          <div className="course-term">{this.props.course.term}</div>
        </div>
      </li>
    );
  }
}

export default Course;

Course.propTypes = {
  course: PropTypes.shape({
    number: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    term: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    _id: PropTypes.string.isRequired,
    color: PropTypes.string,
  }).isRequired,
  updateCourse: PropTypes.func.isRequired,
  removeCourse: PropTypes.func.isRequired,
}
